import { useState } from "react";

import {
  codAreaContactValidator,
  codCountryContactValidator,
  emailContactValidator,
  messageContactValidator,
  nameContactValidator,
  phoneContactValidator,
  subjectContactValidator,
} from '../helpers/validators';

const touchErrors = errors => {
  return Object.entries(errors).reduce((acc, [field, fieldError]) => {
    acc[field] = {
      ...fieldError,
      dirty: true,
    };
    return acc;
  }, {});
}

export const useContactoFormValidator = form => {
  const [errors, setErrors] = useState({
    name: {
      dirty: false,
      error: false,
      message: "",
    },
    company: {
      dirty: false,
      error: false,
      message: "",
    },
    email: {
      dirty: false,
      error: false,
      message: "",
    },
    codCountry: {
      dirty: false,
      error: false,
      message: "",
    },
    codArea: {
      dirty: false,
      error: false,
      message: "",
    },
    phone: {
      dirty: false,
      error: false,
      message: "",
    },
    subject: {
      dirty: false,
      error: false,
      message: "",
    },
    message: {
      dirty: false,
      error: false,
      message: "",
    },
  });

  const validateForm = ({ form, field, errors, forceTouchErrors = false }) => {
    let isValid = true;

    let nextErrors = JSON.parse(JSON.stringify(errors));

    if (forceTouchErrors) {
      nextErrors = touchErrors(errors);
    }

    const { name, email, codCountry, codArea, phone, subject, message } = form;

    if (nextErrors.name.dirty && (field ? field === "name" : true)) {
      const nameMessage = nameContactValidator(name, form)
      nextErrors.name.error = !!nameMessage;
      nextErrors.name.message = nameMessage;
      if (!!nameMessage) isValid = false
    }


    if (nextErrors.email.dirty && (field ? field === "email" : true)) {
      const emailMessage = emailContactValidator(email, form)
      nextErrors.email.error = !!emailMessage;
      nextErrors.email.message = emailMessage;
      if (!!emailMessage) isValid = false
    }

    if (nextErrors.codCountry.dirty && (field ? field === "codCountry" : true)) {
      const codCountryMessage = codCountryContactValidator(codCountry, form)
      nextErrors.codCountry.error = !!codCountryMessage;
      nextErrors.codCountry.message = codCountryMessage;
      if (!!codCountryMessage) isValid = false
    }

    if (nextErrors.codArea.dirty && (field ? field === "codArea" : true)) {
      const codAreaMessage = codAreaContactValidator(codArea, form)
      nextErrors.codArea.error = !!codAreaMessage;
      nextErrors.codArea.message = codAreaMessage;
      if (!!codAreaMessage) isValid = false
    }

    if (nextErrors.phone.dirty && (field ? field === "phone" : true)) {
      const phoneMessage = phoneContactValidator(phone, form)
      nextErrors.phone.error = !!phoneMessage;
      nextErrors.phone.message = phoneMessage;
      if (!!phoneMessage) isValid = false
    }

    if (nextErrors.subject.dirty && (field ? field === "subject" : true)) {
      const subjectMessage = subjectContactValidator(subject, form)
      nextErrors.subject.error = !!subjectMessage;
      nextErrors.subject.message = subjectMessage;
      if (!!subjectMessage) isValid = false
    }

    if (nextErrors.message.dirty && (field ? field === "message" : true)) {
      const messageMessage = messageContactValidator(message, form)
      nextErrors.message.error = !!messageMessage;
      nextErrors.message.message = messageMessage;
      if (!!messageMessage) isValid = false
    }


    setErrors(nextErrors);

    return {
      isValid,
      errors: nextErrors
    }

  }

  const onBlurField = (e) => {
    const field = e.target.name
    const fieldError = errors[field]
    if (fieldError.dirty) return

    const updatedErrors = {
      ...errors,
      [field]: {
        ...errors[field],
        dirty: true
      }
    }

    validateForm({ form, field, errors: updatedErrors })
  }


  return {
    errors,
    validateForm,
    onBlurField,
  }
}